import makeStyles from '@mui/styles/makeStyles';

export const useTimelineStyles = makeStyles((theme) => ({
    root: {
        alignItems: 'flex-start',
        color: '#626466',
        margin: 0,
        padding: 0,
        marginLeft: -5,
    },
    connector: {
        borderStyle: 'dashed',
        borderWidth: 1,
        backgroundColor: 'transparent',
    },
    content: {
        paddingTop: 7,
        '&.margin': {
            marginTop: -5,
        },
    },
    dot: {
        width: 24,
        height: 24,
        borderWidth: 3,
        '&.active': {
            borderColor: '#4EAC6F',
            borderWidth: 5,
        },
        '&.canceled': {
            borderColor: '#E25B61',
            borderWidth: 5,
        },
        '&.small': {
            width: 12,
            height: 12,
        },
    },
    tinySeparator: {
        margin: '0 5px',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    smallText: {
        fontSize: 'small',
    },
    discriminator: {
        borderRadius: '50%',
        width: 14,
        height: 14,
    },
    avatarCustom: {
        width: 'auto !important',
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 15,
        backgroundColor: theme.palette.background.paper,
        color: '#fff',
    },
    chipEpisode: {
        border: 'solid 1px #ffffff',
        borderRadius: 20,
        padding: '6px 12px',
        fontSize: 14,
    },
    inpatientSeparator: {
        marginBottom: 10,
    },
    headerText: {
        color: theme.palette.admissionForm.labelColor,
    },
}));
